'use es6';

import { List, Record } from 'immutable';
export default Record({
  attemptStartTime: undefined,
  attemptFinishTime: undefined,
  attemptRetakeTime: undefined,
  examId: undefined,
  id: undefined,
  isExpired: false,
  passed: false,
  passThreshold: undefined,
  countQuestionsInExam: undefined,
  questions: List(),
  questionSubmissions: List(),
  score: undefined
}, 'ExamAttempt');